
import React from 'react';
import { Switch } from '@/components/ui/switch';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Percent } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';
import * as z from 'zod';

interface DiscountSectionProps {
  form: UseFormReturn<z.infer<any>>;
  applyDiscount: boolean;
  setApplyDiscount: React.Dispatch<React.SetStateAction<boolean>>;
}

const DiscountSection: React.FC<DiscountSectionProps> = ({
  form,
  applyDiscount,
  setApplyDiscount,
}) => {
  return (
    <>
      <div className="flex items-center gap-2">
        <Switch 
          id="enableDiscount" 
          checked={applyDiscount}
          onCheckedChange={setApplyDiscount}
        />
        <label htmlFor="enableDiscount" className="font-medium cursor-pointer flex items-center gap-1">
          <Percent className="h-4 w-4" />
          Apply discount to this product
        </label>
      </div>
      
      {applyDiscount && (
        <FormField
          control={form.control}
          name="discount"
          render={({ field }) => (
            <FormItem className="pl-6 border-l-2 border-gray-200">
              <FormLabel>Discount Percentage (%)</FormLabel>
              <FormControl>
                <Input 
                  type="number" 
                  min="0" 
                  max="100" 
                  placeholder="e.g., 10 for 10% discount" 
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </>
  );
};

export default DiscountSection;
